import { ViewFactory } from 'wdc-cube-react'
import AnaliseSelectScope from '../analise_select.scopes'
import AnaliseSelectView from './analise_select.view'

export function registerViews(rv = ViewFactory.register) {
    rv(AnaliseSelectScope, AnaliseSelectView)
}
